// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Icon$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/icons/Icon.bs.js";
import * as CountryContext from "../../../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as Accordion$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/Accordion.bs.js";
import * as DriverRecordsStore from "../../DriverRecordsStore.bs.js";
import * as AccordionAPIWrapper from "../../../../vm-mapper/driver-records/AccordionSections/AccordionAPIWrapper.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as FooterActions$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/FooterActions.bs.js";
import * as AccordionTypes$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/AccordionTypes.bs.js";
import * as CollapsedHeader$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/CollapsedHeader.bs.js";
import * as ServiceabilityViewMapper from "../../../../vm-mapper/driver-records/ServiceabilityViewMapper.bs.js";
import * as SectionHeaderComponent$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/section-header/SectionHeaderComponent.bs.js";
import * as CrmAccordianStatusLabel$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/CrmAccordianStatusLabel.bs.js";
import * as FetchLoadableViewMapper$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/FetchLoadableViewMapper.bs.js";

function getCrmServiceabilityStatus(is_enabled, is_active) {
  if (is_enabled) {
    if (is_active !== undefined && is_active === true) {
      return /* Active */0;
    } else {
      return /* Inactive */1;
    }
  } else {
    return /* NotAvailable */2;
  }
}

function getServiceabilityInfoAction(workspace_dispatch, tab) {
  return ButtonUtils$Catalyst.getDefaultButtonProps({
              TAG: /* Text */0,
              _0: "View More"
            }, undefined, (function (param) {
                return Curry._2(workspace_dispatch.addTab, tab, false);
              }), undefined, Caml_option.some(React.createElement(Icon$Catalyst.NavigateIcon.make, {
                      fontSize: "Default"
                    })), undefined, undefined, undefined, undefined, undefined);
}

function getServiceabilityAccordionPanel(serviceabilityInfo, title, status, workspace_dispatch, tab, onOpen) {
  return AccordionTypes$Catalyst.make_props({
              TAG: /* Custom */1,
              _0: (function (param) {
                  return React.createElement(CollapsedHeader$Catalyst.make, {
                              title: title,
                              children: React.createElement(CrmAccordianStatusLabel$Catalyst.make, {
                                    status: status
                                  })
                            });
                })
            }, Caml_option.some(React.createElement(FetchLoadableViewMapper$Catalyst.make, {
                      loadableData: serviceabilityInfo,
                      children: (function (serviceabilityData) {
                          return React.createElement(FooterActions$Catalyst.make, {
                                      actions: List.length(Belt_Option.mapWithDefault(serviceabilityData.sessions, /* [] */0, (function (x) {
                                                  return x;
                                                }))) > 5 ? ({
                                            hd: getServiceabilityInfoAction(workspace_dispatch, tab),
                                            tl: /* [] */0
                                          }) : /* [] */0
                                    });
                        }),
                      loadingData: null
                    })), onOpen, ServiceabilityViewMapper.getView(serviceabilityInfo), undefined);
}

function getServiceabilityAccordionPanels(msisdn, driverInfo, helperServiceabilityInfo, outStationServiceabilityInfo, helperLabourServiceability, rentalServiceability, workspace_dispatch, dispatch) {
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var helperStatus = getCrmServiceabilityStatus(driverInfo.driverProfile.actAsHelper.feature_enabled, driverInfo.driverProfile.actAsHelper.is_active);
  var outStationStatus = getCrmServiceabilityStatus(driverInfo.driverProfile.outStation.feature_enabled, driverInfo.driverProfile.outStation.is_active);
  var helperLabourStatus = getCrmServiceabilityStatus(driverInfo.driverProfile.helperLabour.feature_enabled, driverInfo.driverProfile.helperLabour.is_active);
  var rentalStatus = getCrmServiceabilityStatus(driverInfo.driverProfile.rental.feature_enabled, driverInfo.driverProfile.rental.is_active);
  if (country.TAG === /* India */1) {
    return {
            hd: getServiceabilityAccordionPanel(helperServiceabilityInfo, "Act as Helper", helperStatus, workspace_dispatch, {
                  TAG: /* HelperServiceabilityInfoList */36,
                  _0: msisdn
                }, (function (param) {
                    return AccordionAPIWrapper.fetchUnloadedData(helperServiceabilityInfo, (function (param) {
                                  return DriverRecordsStore.loadHelperServiceabilityInfo(msisdn, dispatch, country);
                                }));
                  })),
            tl: {
              hd: getServiceabilityAccordionPanel(outStationServiceabilityInfo, "Outstation", outStationStatus, workspace_dispatch, {
                    TAG: /* OutStationServiceabilityInfoList */37,
                    _0: msisdn
                  }, (function (param) {
                      return AccordionAPIWrapper.fetchUnloadedData(outStationServiceabilityInfo, (function (param) {
                                    return DriverRecordsStore.loadOutStationServiceabilityInfo(msisdn, dispatch, country);
                                  }));
                    })),
              tl: {
                hd: getServiceabilityAccordionPanel(helperLabourServiceability, "Labour + Helper", helperLabourStatus, workspace_dispatch, {
                      TAG: /* HelperLabourServiceability */45,
                      msisdn: msisdn
                    }, (function (param) {
                        return AccordionAPIWrapper.fetchUnloadedData(helperLabourServiceability, (function (param) {
                                      return DriverRecordsStore.loadHelperLabourServiceabilityInfo(msisdn, dispatch, country);
                                    }));
                      })),
                tl: {
                  hd: getServiceabilityAccordionPanel(rentalServiceability, "Rental Status", rentalStatus, workspace_dispatch, {
                        TAG: /* RentalServiceabilityInfoList */38,
                        _0: msisdn
                      }, (function (param) {
                          return AccordionAPIWrapper.fetchUnloadedData(rentalServiceability, (function (param) {
                                        return DriverRecordsStore.loadRentalServiceabilityInfo(msisdn, dispatch, country);
                                      }));
                        })),
                  tl: /* [] */0
                }
              }
            }
          };
  } else {
    return {
            hd: getServiceabilityAccordionPanel(outStationServiceabilityInfo, "Outstation", outStationStatus, workspace_dispatch, {
                  TAG: /* OutStationServiceabilityInfoList */37,
                  _0: msisdn
                }, (function (param) {
                    return AccordionAPIWrapper.fetchUnloadedData(outStationServiceabilityInfo, (function (param) {
                                  return DriverRecordsStore.loadOutStationServiceabilityInfo(msisdn, dispatch, country);
                                }));
                  })),
            tl: /* [] */0
          };
  }
}

function CrmServiceabilitySection(Props) {
  var msisdn = Props.msisdn;
  var driverInfo = Props.driverInfo;
  var helperServiceabilityInfo = Props.helperServiceabilityInfo;
  var workspace_dispatch = Props.workspace_dispatch;
  var outStationServiceabilityInfo = Props.outStationServiceabilityInfo;
  var helperLabourServiceability = Props.helperLabourServiceability;
  var rentalServiceability = Props.rentalServiceability;
  var dispatch = Props.dispatch;
  return React.createElement("div", {
              className: "section-container"
            }, React.createElement(SectionHeaderComponent$Catalyst.make, {
                  heading: "Serviceabililty"
                }), React.createElement(FetchLoadableViewMapper$Catalyst.make, {
                  loadableData: driverInfo,
                  children: (function (driverData) {
                      return React.createElement(Accordion$Catalyst.make, {
                                  panels: getServiceabilityAccordionPanels(msisdn, driverData, helperServiceabilityInfo, outStationServiceabilityInfo, helperLabourServiceability, rentalServiceability, workspace_dispatch, dispatch),
                                  className: "accordion-container"
                                });
                    })
                }));
}

var make = CrmServiceabilitySection;

export {
  getCrmServiceabilityStatus ,
  getServiceabilityInfoAction ,
  getServiceabilityAccordionPanel ,
  getServiceabilityAccordionPanels ,
  make ,
  
}
/* react Not a pure module */
